import { SuspenseErrorBoundary } from '@/components/errorBoundary/SuspenseErrorBoundary';
import ObservablesList, {
  ObservablesListSuspenseFallback,
} from '@/pages/explore/observables/_partials/ObservablesList';

export default function Observables() {
  return (
    <SuspenseErrorBoundary
      suspenseFallback={<ObservablesListSuspenseFallback />}
    >
      <ObservablesList />
    </SuspenseErrorBoundary>
  );
}
